import Card from '@/components/Card';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
export const Route = createFileRoute('/import-profile/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <div className="h-screen w-full flex flex-col gap-8 items-center justify-center overflow-y-auto p-4">
      <header className="text-center">
        <h1 className="h1 mb-2">{t('import-profile.title')}</h1>
        <p className="body-1 text-gray">{t('import-profile.description')}</p>
      </header>
      <main className="flex flex-col gap-2 items-stretch w-full max-w-[450px]">
        <Card
          title={t('import-profile.linkedin_title')}
          description={t('import-profile.linkedin_description')}
          to="/import-profile/linkedin"
        />
        <Card
          title={t('import-profile.existing_title')}
          description={t('import-profile.existing_description')}
          to="/import-profile/existing"
        />
        <Card
          title={t('import-profile.fill_from_zero_title')}
          description={t('import-profile.fill_from_zero_description')}
          to="/import-profile/edit-profile?method=fill-from-zero"
        />
      </main>
    </div>
  );
}
